import FineUploaderTraditional from 'fine-uploader-wrappers'

export default (context, inject) => {
  inject('FineUploaderTraditional', FineUploaderTraditional)
}
